import { containsDevanagari } from './englishOnly.mjs';

export type UiLanguage = 'hi' | 'en';
export type InterfaceLanguage = UiLanguage | 'custom';

const HI_TO_EN: Record<string, string> = {
  'API से जुड़ रहे हैं': 'Connecting to API',
  'API से कनेक्शन नहीं हुआ। स्थानीय सर्वर चालू है?': 'API connection failed. Is the server reachable?',
  'API request विफल': 'API request failed',
  'स्रोतों को जाँचना शुरू हुआ': 'Feed refresh started',
  'Refresh अनुरोध विफल': 'Refresh request failed',
  'स्थानीय AI से दोबारा वर्गीकृत': 'Reclassified by local AI',
  'प्रतीक्षा में': 'Waiting',
  'सार्वजनिक स्रोत · स्वचालित वर्गीकरण': 'Public sources · automated classification',
  'सिंक हो रहा है': 'Syncing',
  'अब अपडेट करें': 'Refresh now',
  'स्रोत स्वास्थ्य': 'Source health',
  'स्थिति': 'Status',
  'पैनल': 'Panel',
  'API retry हो रहा है। समस्या बनी रहे तो API server logs देखें।': 'The API is retrying. Check the API server logs if the problem persists.',
  'वर्तमान dashboard metrics': 'Current dashboard metrics',
  'सभी रिपोर्ट': 'All reports',
  'इस डिवाइस पर': 'On this device',
  'मानचित्रित स्थान': 'Mapped locations',
  'स्थानीय gazetteer': 'Local gazetteer',
  'संघर्ष / सैन्य': 'Conflict / military',
  'रिपोर्ट वर्गीकरण': 'Report classification',
  'उच्च / गंभीर': 'High / critical',
  'स्वचालित संकेत': 'Automated signals',
  'स्रोत उपलब्ध': 'sources available',
  'अंतिम sync': 'Last sync',
  'नियंत्रण': 'Controls',
  'वैश्विक गतिविधि': 'Global activity',
  'मानचित्र': 'map',
  'घटनाएँ': 'events',
  'रीसेट': 'Reset',
  'क्षेत्र फ़िल्टर:': 'Region filter:',
  '3D ग्लोब लोड हो रहा है': 'Loading 3D globe',
  'मानचित्र डेटा लोड हो रहा है': 'Loading map data',
  'कोई मिलान करता भू-स्थानिक संकेत नहीं': 'No geolocated signals match',
  'फीड refresh होने दें या फ़िल्टर बदलें।': 'Let feeds refresh or adjust filters.',
  'समाचार संकेत': 'News signals',
  'सैन्य रिपोर्ट': 'Military reports',
  'संघर्ष रिपोर्ट': 'Conflict reports',
  'ऊँचा खतरा': 'Elevated threat',
  'स्थान नाम से अनुमानित': 'Location estimated from text',
  'रिपोर्ट map-ready': 'reports map-ready',
  'रिपोर्ट समूह': 'Report clusters',
  'स्थानिक समूह': 'geospatial groups',
  'स्थान पहचाना नहीं': 'Location not identified',
  'रिपोर्ट': 'reports',
  'स्रोत': 'sources',
  'क्षेत्र या category पहचानने के लिए नई RSS रिपोर्ट प्रतीक्षित है।': 'Waiting for new RSS reports to identify a region or category.',
  'रिपोर्ट व विवरण': 'Reports & details',
  'अपडेट': 'Updated',
  'फ़ीड अभी fetch करें': 'Fetch feeds now',
  'प्रकाशक ने सारांश नहीं दिया।': 'No summary supplied by publisher.',
  'प्रकाशक ने सारांश नहीं दिया। मूल रिपोर्ट पढ़ें।': 'No summary supplied. Open the original report.',
  'पहली फ़ीड जाँच जारी है': 'First feed check in progress',
  'अगली जाँच में सार्वजनिक RSS आइटम यहाँ दिखाई देंगे।': 'Public RSS items will appear here after the next check.',
  'कोई रिपोर्ट इन फ़िल्टर से मेल नहीं खाती': 'No reports match these filters',
  'फ़िल्टर साफ़ करें या अधिक समय सीमा चुनें।': 'Clear filters or choose a wider time range.',
  'अभी रिपोर्ट नहीं मिली': 'No reports yet',
  'फ़ीड उपलब्धता नेटवर्क और प्रकाशक पर निर्भर है।': 'Feed availability depends on the network and publisher.',
  'फ़िल्टर हटाएँ': 'Clear filters',
  'रिपोर्ट विवरण': 'Report details',
  'प्रकाशन समय': 'Published',
  'स्थान': 'Location',
  'नाम से नहीं पहचाना गया': 'Not identified by name',
  'मैप/वर्ग confidence': 'Map / class confidence',
  'वर्गीकरण': 'classification',
  'मेल खाते संकेत': 'Matched signals',
  'कोई विशिष्ट keyword नहीं': 'No specific keywords matched',
  'मूल रिपोर्ट': 'Open source',
  'स्वचालित संकेत सार्वजनिक समाचार पाठ से निकले हैं। खतरा और स्थान स्वतंत्र रूप से सत्यापित नहीं हैं।': 'Automated signals are derived from public news text; threat and location are not independently verified.',
  'एक रिपोर्ट चुनें': 'Select a report',
  'समाचार या ग्लोब मार्कर चुनने पर स्रोत और वर्गीकरण विवरण यहाँ दिखेगा।': 'Select a story or globe marker to see source and classification details.',
  'स्थानीय मॉडल': 'Local model',
  'Ollama वैकल्पिक · नियम डिफ़ॉल्ट': 'Ollama optional · rules are the default',
  'स्थानीय AI से reclassify': 'Reclassify with local AI',
  'स्वचालित': 'automatic',
  'लाइव फ़ीड': 'Live feed',
  'API DISCONNECTED': 'API DISCONNECTED',
  'API CONNECTED': 'API CONNECTED',
  'स्रोत और घटनाएँ खोजें': 'Search sources and events',
  'कीवर्ड, शहर, प्रकाशक…': 'Keyword, city, publisher…',
  'श्रेणी': 'Category',
  'सभी विषय': 'All topics',
  'सामान्य समाचार': 'General news',
  'संघर्ष': 'Conflict',
  'सैन्य गतिविधि': 'Military activity',
  'कूटनीति': 'Diplomacy',
  'आपदा': 'Disaster',
  'साइबर': 'Cyber',
  'राजनीति': 'Politics',
  'अर्थव्यवस्था': 'Economy',
  'खतरा': 'Threat',
  'सभी स्तर': 'All levels',
  'समय सीमा': 'Time range',
  '24 घंटे': '24 hours',
  '3 दिन': '3 days',
  '7 दिन': '7 days',
  'सभी': 'All time',
  'समाचार घटनाएँ': 'News events',
  'वैश्विक रिपोर्टिंग': 'Global reporting',
  'सार्वजनिक रिपोर्ट': 'Public reporting',
  'संघर्ष क्षेत्र': 'Conflict zones',
  'ऊँचे खतरे': 'Elevated threats',
  'उच्च / गंभीर संकेत': 'High / critical signals',
  'जाँचे गए स्रोत': 'checked sources',
  'पहली जाँच प्रतीक्षित': 'First check pending',
  'उपलब्ध': 'available',
  'त्रुटि': 'errors',
  'स्रोत जाँच': 'source check',
  'स्थानीय वर्गीकरण': 'Local classification',
  'Rules v1 · कोई cloud key नहीं': 'Rules v1 · no cloud key',
  'डेटा स्रोत': 'Data source',
  'सार्वजनिक RSS': 'Public RSS',
  'तरीका': 'Method',
  'स्वचालित · सत्यापन आवश्यक': 'Automated · verification required',
  'वैश्विक संकेत—स्रोत सहित।': 'Global signals—with sources.',
  'समाचार संकेत—स्वतंत्र सत्यापन आवश्यक।': 'News signals—independent verification required.',
  'रिपोर्ट को किसी भी भाषा में पढ़ें': 'Read this report in any language',
  'लक्ष्य भाषा': 'Target language',
  'भाषा का नाम लिखें': 'Enter a language name',
  'अनुवाद करें': 'Translate',
  'अनुवाद हो रहा है…': 'Translating…',
  'अनुवाद': 'Translation',
  'मूल पाठ सुरक्षित है': 'Original text is preserved',
  'अनुवाद के लिए स्थानीय Ollama चालू करें।': 'Start local Ollama to translate.',
  'अनुवाद विफल': 'Translation failed',
  'पुनः प्रयास': 'Retry connection',
  'API से पुनः जुड़ें': 'Reconnect to API',
  'प्रति 25 सेकंड UI अपडेट · feed polling': 'UI updates every 25 seconds · feed polling',
  'रिपोर्ट पढ़ने के लिए target language लिखें': 'Enter any target language to read this report',
  'समय अनुपलब्ध': 'Time unavailable',
  'अभी तक नहीं': 'Not yet',
  'अभी': 'Just now',
  'क्षेत्र देखने के लिए क्लिक करें': 'Click to filter this region',
  'इंटरैक्टिव विश्व ग्लोब': 'Interactive world globe',
  'क्षेत्र': 'Region',
  'पृथ्वी · 3D': 'Earth · 3D',
  'इंटरफ़ेस भाषा': 'Interface language',
  'बंद करें': 'Close',
  'फ़िल्टर': 'FILTERS',
  'मानचित्र परतें': 'MAP LAYERS',
  'स्रोत स्थिति': 'SOURCE HEALTH',
  'वैश्विक मानचित्र': 'GLOBAL MAP',
  'घटना समूह': 'EVENT CLUSTERS',
  'खुला फ़ीड': 'OPEN FEED',
  'चयनित रिपोर्ट': 'SELECTED REPORT',
  'आइटम': 'ITEMS',
  'वैश्विक संकेत डेस्क': 'GLOBAL SIGNAL DESK',
  'ओपन-सोर्स मॉनिटर': 'OPEN-SOURCE MONITOR',
  'सिंक जारी': 'SYNCING',
  'ऑफ़लाइन': 'OFFLINE',
  'लाइव फीड्स': 'LIVE FEEDS',
  'यूटीसी': 'UTC',
  'OSINT कवरेज': 'OSINT COVERAGE',
  'स्थान-निर्धारित संकेत': 'GEOLOCATED SIGNALS',
  'घुमाने के लिए खींचें': 'DRAG TO ROTATE',
  'ज़ूम के लिए स्क्रॉल करें': 'SCROLL TO ZOOM',
  'सार्वजनिक रिपोर्टिंग · सेंसर ट्रैकिंग नहीं': 'PUBLIC REPORTING · NOT SENSOR TRACKING',
  'स्थानीय AI': 'LOCAL AI',
  'सार्वजनिक-स्रोत इंटेलिजेंस': 'PUBLIC-SOURCE INTELLIGENCE',
  'इंटरफ़ेस भाषा चुनें': 'Choose interface language',
  'हमेशा मूल स्रोत की जाँच करें।': 'Always verify against the original source.',
  'कोई भी भाषा': 'Any language',
  'कस्टम भाषा का नाम': 'Enter custom language',
  'वेबसाइट की भाषा बदलें': 'Translate interface',
  'UI अनुवाद उपलब्ध नहीं': 'Custom interface translation is unavailable',
  'भाषा के labels बदले जा रहे हैं…': 'Translating interface labels…',
  'कस्टम UI अनुवाद के लिए स्थानीय Ollama चालू करें।': 'Start local Ollama to translate a custom interface.',
  'कस्टम भाषा सेट करने के लिए target language लिखें।': 'Enter a target language to translate the interface.',
  'कस्टम भाषा चुनी गई है।': 'A custom language is selected.',
  'थीम चुनें': 'Choose theme',
  'डार्क': 'Dark',
  'लाइट': 'Light',
  'YouTube Live': 'YouTube Live',
  'YouTube पर खोजें': 'Search YouTube Live',
  'स्वामी': 'Owner',
  'भारत': 'India',
  'घटना समयरेखा': 'Event timeline',
  'समयरेखा': 'Timeline',
  'समयरेखा चलाएँ': 'Play timeline',
  'समयरेखा रोकें': 'Pause timeline',
  'चलाएँ': 'Play',
  'रोकें': 'Pause',
  'समयरेखा स्थिति': 'Timeline position',
  'सबसे पुरानी': 'Oldest',
  'नवीनतम': 'Newest',
  'समयरेखा के लिए अभी कोई घटना नहीं': 'No events yet for the timeline',
  'घटना इतिहास': 'Incident history',
  'Watchlist और alerts': 'Watchlist & alerts',
  'इस browser में सुरक्षित': 'Saved in this browser',
  'नियम का प्रकार': 'Rule type',
  'कीवर्ड / विषय': 'Keyword / topic',
  'देश': 'Country',
  'प्रकाशक': 'Publisher',
  'शब्द, देश या publisher लिखें': 'Enter a keyword, country or publisher',
  'Watch rule जोड़ें': 'Add watch rule',
  'निगरानी नियम': 'Watch rules',
  'मिलती रिपोर्ट': 'matching reports',
  'अभी watch rules नहीं हैं': 'No watch rules yet',
  'अलर्ट इतिहास': 'Alert history',
  'अलर्ट साफ़ करें': 'Clear alerts',
  'अभी कोई alert नहीं': 'No alerts yet',
  'मिलान हुआ': 'Matched',
  'अलर्ट नई reports पर तभी बनते हैं जब dashboard खुला हो।': 'Alerts are generated only for new reports while the dashboard is open.',
  'अक्षम करें': 'Disable',
  'सक्षम करें': 'Enable',
  'हटाएँ': 'Remove',
  'स्रोत गुणवत्ता': 'Source quality',
  'ताज़ा': 'Fresh',
  'विफल': 'Failed',
  'पुराना स्रोत': 'Stale',
  'जाँच प्रतीक्षित': 'Awaiting check',
  'यह feed की तकनीकी स्थिति है, खबर की सत्यता का अंक नहीं।': 'This is technical feed health, not a score of story accuracy.',
  'समाचार वर्गीकरण': 'News classification',
  'निम्न': 'Low',
  'मध्यम': 'Medium',
  'उच्च': 'High',
  'गंभीर': 'Critical',
  'स्रोत खोजें…': 'Search sources…',
  'आखिरी जाँच': 'Last check',
  'आखिरी सफल': 'Last success',
  'लेटेंसी': 'Latency',
  'लगातार विफल जाँच': 'consecutive failed checks',
  'प्रत्यक्ष RSS': 'Direct publisher RSS',
  'Google News माध्यम': 'Google News mediated',
  'प्रकाशक की साइट खोलें': 'Open publisher site',
  'कोई स्रोत नहीं मिला': 'No sources found',
  'आखिरी सफल समय': 'Last successful time',
  'वर्गीकरण मॉडल': 'Classifier',
  'नई watchlist अलर्ट': 'new watchlist alerts'
};

const EN_TO_HI = Object.fromEntries(Object.entries(HI_TO_EN).map(([hi, en]) => [en, hi]));

let customDictionary: Record<string, string> = {};

export function setCustomUiDictionary(dictionary: Record<string, string>): void {
  customDictionary = dictionary;
}

export function getUiSourceStrings(): string[] {
  return Object.keys(HI_TO_EN);
}

export function uiText(language: InterfaceLanguage, text: string): string {
  let result: string;
  if (language === 'custom') {
    const status = text.match(/^(\d+)\/(\d+) स्रोत उपलब्ध$/u);
    if (status) result = `${status[1]}/${status[2]} ${customDictionary['स्रोत उपलब्ध'] ?? HI_TO_EN['स्रोत उपलब्ध']}`;
    else {
    const hindiSource = Object.hasOwn(HI_TO_EN, text) ? text : EN_TO_HI[text];
      result = hindiSource ? customDictionary[hindiSource] ?? HI_TO_EN[hindiSource] ?? text : text;
    }
  } else {
    const englishSource = Object.hasOwn(HI_TO_EN, text) ? text : EN_TO_HI[text];
    result = englishSource ? HI_TO_EN[englishSource] ?? text : text;
  }
  return containsDevanagari(result) ? 'Status update' : result;
}

export function categoryText(language: InterfaceLanguage, category: string): string {
  return uiText(language, category);
}

export function threatText(language: InterfaceLanguage, threat: string): string {
  return uiText(language, threat);
}
